export enum STEP_TITLE_KEY {
   FIRST_STEP = 'progress-bar.step-1',
   SECOND_STEP = 'progress-bar.step-2',
   THIRD_STEP = 'progress-bar.step-3',
   FOURTH_STEP = 'progress-bar.step-4',
}

export enum PROGRESS_BAR_STEP_ENUM {
  FIRST_STEP = 1,
  SECOND_STEP,
  THIRD_STEP,
  FOURTH_STEP,
}

export type PROGRESS_BAR_STEPS_TYPE = Array<{title: STEP_TITLE_KEY}>;

export const PROGRESS_BAR_STEPS: Array<{title: STEP_TITLE_KEY}> = [
  {
    title: STEP_TITLE_KEY.FIRST_STEP,
  },
  {
    title: STEP_TITLE_KEY.SECOND_STEP,
  },
  {
    title: STEP_TITLE_KEY.THIRD_STEP,
  },
  {
    title: STEP_TITLE_KEY.FOURTH_STEP,
  },
];
